<template>
<div class="footer pb-5">
    <div class="container row-foot">
        <div class="footer-topbox footer-margin">
            <b-row class="justify-content-center text-center">
                <b-col cols="12" md="3">
                     <img class="footer-logo-img" src="../assets/images/culture-logo.png" alt="" />
                </b-col>
                <b-col cols="12" md="5"> <span class="f-32"> Have a <em class="em-color bold"> Question?</em> </span><br>
                    Find answers to your <em class="em-color">curiosity</em> from our experienced team
                </b-col>
                <b-col cols="6" md="4">
                    <router-link to="/contact-us" class="btn btn-warning text-white">Contact Us
                        <font-awesome-icon :icon="['fas', 'arrow-right']" />
                    </router-link>
                </b-col>
            </b-row>

        </div>
        <div class="footer-margin mt-5">
            <b-row>
                <b-col cols="6" md="2">
                    <ul class="link-title">
                        <li>Get to know Us</li>
                        <li>
                            <router-link to="/about-us"> About Us </router-link>
                        </li>
                        <li>
                            <router-link to="/contact-us"> Contact Us </router-link>
                        </li>
                        <li>
                            <a target="_blank" href="https://stores.culturesquare.com/blog"> Blog </a>
                        </li>
                        <li>
                            <router-link to="/careers"> Careers </router-link>
                        </li>
                        <li>
                            <router-link to="/donate"> Donate </router-link>
                        </li>

                    </ul>
                </b-col>
                <b-col cols="6" md="2">
                    <ul class="link-title">
                        <li>The Culture</li>
                        <li>
                            <router-link to="/recipes"> Recipes </router-link>
                        </li>
                        <li>
                            <a target="_blank" href="https://stores.culturesquare.com/vendor/dashboard"> Sell </a>
                        </li>
                        <li>
                            <a target="_blank" href="https://stores.culturesquare.com"> Buy </a>
                        </li>
                        <li>
                            <router-link to="/refunds"> Refunds </router-link>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="6" md="3">
                    <ul class="link-title">
                        <li>Related Links</li>
                        <li>
                            <router-link to="/accounts/signup"> Register </router-link>
                        </li>
                        <li>
                            <router-link to="/profile"> Account </router-link>
                        </li>
                        <li>
                            <router-link to="/disclaimers"> Disclaimers </router-link>
                        </li>
                        <li>
                            <router-link to="/privacy-policy"> Privacy Policy </router-link>
                        </li>
                        <li>
                            <router-link to="/faqs"> FAQs </router-link>
                        </li>
                    </ul>
                </b-col>
                <b-col cols="6" md="3">
                    <ul class="link-title">
                        <li>Languages</li>
                        <li>
                            <router-link to="/languages"> Languages </router-link>
                        </li>
                        <li>
                            <router-link to="/languages/clubs/create"> Create a language club </router-link>
                        </li>
                        <li>
                            <router-link to="/languages/clubs"> Join a language club </router-link>
                        </li>

                        <li>
                            <router-link to="/languages/events/create"> Become an Instructor </router-link>
                        </li>
                        <li>
                            <router-link to="/languages/events"> Become a Student </router-link>
                        </li>

                    </ul>
                </b-col>
                <b-col cols="6" md="2">
                    <ul class="link-title">
                        <li>Events</li>
                        <li>
                            <router-link to="/listings/events"> Events </router-link>
                        </li>
                        <li>
                            <router-link to="/listings/events/create"> Host Events </router-link>
                        </li>
                        <li>
                            <router-link to="/listings/events"> Attend Events </router-link>
                        </li>

                    </ul>
                </b-col>
            </b-row>
        </div>

    </div>
    <div class="text-center icons-section">
        <p>
            Follow Us
        </p>
        <p>
            <a target="_blank" href="https://www.linkedin.com/company/csquareplatform" class="mr-2"> <b-icon font-scale="1" icon="linkedin"></b-icon> </a>
            <a target="_blank" href="https://twitter.com/csquareplatform" class="mr-2"> <b-icon font-scale="1" icon="twitter"></b-icon></a>
            <a target="_blank" href="https://www.facebook.com/csquareplatform" class="mr-2"><b-icon font-scale="1" icon="facebook"></b-icon></a>
            <a target="_blank" href="https://www.instagram.com/csquareplatform"> <b-icon font-scale="1" icon="instagram"></b-icon></a>
        </p>
        <p>&#169; {{year}} Culture Square LLC. All Rights Reserved</p>
    </div>
</div>
</template>

<script>
export default {
    name: "foota",
    computed: {
        year: function () {
            var dt = new Date();
            return dt.getFullYear()
        }

    }
}
</script>

<style lang="scss" scoped>
.footer {
    background: #000;
    height: auto;
    color: #fff;
    padding-top: 115px;
    margin-top: 100px
}

.footer a {
    color: #C4C4C4
}

.icons-section {
    margin-top: 3rem
}

.footer-topbox {
    border: 1px solid #ccc;
    padding: 30px 10px;
    border-radius: 4px;
}

ul {
    padding-left: 0 !important
}

.row-foot {
    padding-bottom: 70px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.footer-margin {
    margin: 0 70px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        margin: 0 20px;

    }
}

.footer-logo-img {
    padding-left: 70px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding-left: 0px
    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        padding-left: 0px
    }
}

.f-32 {
    font-size: 32px
}

.em-color {
    color: #F7B131;
}

.bold {
    font-weight: 700;
}

.btn-warning {
    margin-top: 15px;
    padding: 20px 50px;

    @media screen and (min-device-width: 320px) and (max-device-width: 640px) and (-webkit-min-device-pixel-ratio: 1) {
        padding: 10px;

    }

    @media screen and (min-device-width: 760px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {

        margin-top: 17px;
        padding: 5px 47px;
    }

}

.mt-5 {
    margin-top: 5rem !important
}

.link-title li {
    font-family: 'Poppins' !important;
    font-weight: 300;
    color: #C4C4C4;
    margin-top: 10px;
    font-size: 14px
}

.link-title li:first-child {
    font-size: 1rem;
    font-family: 'Montserrat' !important;
    padding-bottom: 10px;
    font-weight: normal;
    color: #fff
}

.mr- {
    margin: 0 1rem;
}
</style>
